import type { UnlockableDef } from '../../data/schema';
import type { Meta } from '../../net/progress';

/** Nombre maximal de modificateurs de run actifs en même temps. */
export const MAX_ACTIVE_MODIFIERS = 2;

/** Achète un débloquable en Ogrines ; `null` s'il est déjà possédé, gratuit (obtenu uniquement par succès) ou trop cher. N'altère pas `meta`. */
export function buyUnlockable(meta: Meta, def: UnlockableDef): Meta | null {
  if (meta.unlocks.includes(def.id) || def.price <= 0 || meta.ogrines < def.price) return null;
  return { ...meta, ogrines: meta.ogrines - def.price, ogrinesSpent: meta.ogrinesSpent + def.price, unlocks: [...meta.unlocks, def.id] };
}

/** Active ou désactive un modificateur pour la prochaine run ; un troisième actif est refusé (la même `meta` est renvoyée). */
export function toggleModifier(meta: Meta, id: string): Meta {
  if (meta.activeModifiers.includes(id)) return { ...meta, activeModifiers: meta.activeModifiers.filter((m) => m !== id) };
  if (meta.activeModifiers.length >= MAX_ACTIVE_MODIFIERS) return meta;
  return { ...meta, activeModifiers: [...meta.activeModifiers, id] };
}
